/**
 * ステータスマッピングユーティリティ
 * useReservationStatusesフックから取得したデータを使用してマッピングを行う
 */

import { StatusCache, StatusCategory } from '../types';

let cachedStatuses: StatusCache | null = null;

/**
 * ステータスキャッシュを設定
 * @param {Object} statuses - rawStatuses from useReservationStatuses
 */
export const setStatusCache = (statuses: StatusCache): void => {
    cachedStatuses = statuses;
};

/**
 * IDからコードを取得
 * @param {number|string} id - ステータスID
 * @param {string} category - カテゴリ ('reservation', 'vehicle', 'vehicle_location')
 * @returns {string|null} ステータスコード
 */
export const getCodeById = (id: number | string, category: StatusCategory = 'reservation'): string | null => {
    if (!cachedStatuses || !cachedStatuses[category]) {
        return null;
    }
    const status = cachedStatuses[category][String(id)];
    return status ? status.code : null;
};

/**
 * コードからIDを取得
 * @param {string} code - ステータスコード
 * @param {string} category - カテゴリ ('reservation', 'vehicle', 'vehicle_location')
 * @returns {number|null} ステータスID
 */
export const getIdByCode = (code: string, category: StatusCategory = 'reservation'): number | null => {
    if (!cachedStatuses || !cachedStatuses[category]) {
        return null;
    }
    const entry = Object.entries(cachedStatuses[category]).find(
        ([_, status]) => status.code === code
    );
    return entry ? parseInt(entry[0]) : null;
};

/**
 * キャッシュが利用可能かチェック
 * @returns {boolean}
 */
export const hasStatusCache = (): boolean => {
    return cachedStatuses !== null;
};

/**
 * キャッシュされたステータスデータを取得
 * @returns {StatusCache | null}
 */
export const getStatusCache = (): StatusCache | null => {
    return cachedStatuses;
};
